import React from 'react';
import { useTranslation } from 'react-i18next';
import './CommunityMembershipPage.scss';
import Button from '../ReusableElements/Buttons/Button/Button';

export default function CommunityMembershipPage() {
  const { t } = useTranslation(['community_membership_page', 'buttons']);

  return (
    <section className="CommunityMembershipPage">
      <div className="wrapper">
        <div className="community-membership-page-content">
          <div className="community-membership-page-content-top-row">
            <a className="previous-page-link" href="/">
              {t('previous_page_title')}
            </a>
            <div className="community-membership-page-content-top-row__right-side">
              <h1 className="heading-one">
                {t('membership_heading')}
              </h1>
              <div className="community-membership-activity">
                <h2 className="heading-two">Хто може стати членом Палати?</h2>
                <ul>
                  <li>Юридичні особи, які створені та діють згідно із законодавством України.</li>
                  <li>Громадяни України, які зареєстровані як підприємці.</li>
                  <li>Об&apos;єднання підприємців.</li>
                </ul>
                <h2 className="heading-two">Для вступу в члени палати:</h2>
                <ul>
                  <li>Заповніть заяву та анкету.</li>
                  <li>
                    Додайте копію документа про державну реєстрацію (витяг з Єдиного державного
                    реєстру юридичних осіб, фізичних осіб-підприємців та громадських формувань).
                  </li>
                  <li>Сплатіть вступний та річний членські внески.</li>
                </ul>
                <p className="paragraph">
                  Прийом у члени Палати здійснюється Президією Івано-Франківської ТПП.
                </p>
                <h2 className="heading-two">Члени Палати мають право:</h2>
                <ul>
                  <li>Брати участь із вирішальним голосом у роботі Конференції Палати.</li>
                  <li>
                    Обирати в порядку, установленому Радою ТПП України, делегатів на З&apos;їзд ТПП
                    України.
                  </li>
                  <li>
                    Обирати і бути обраними до керівних органів Палати, а також органів ТПП України.
                  </li>
                  <li>
                    Виносити на розгляд Конференції, Ради (Президії) Палати, а також З&apos;їзду,
                    Ради й Президії Торгово-промислової палати України пропозиції з питань, що
                    входять у сферу діяльності відповідно Палати й ТПП України.
                  </li>
                  <li>
                    Одержувати необхідну допомогу від Палати й від ТПП України в рішенні питань,
                    що входять у сферу їхньої діяльності.
                  </li>
                </ul>
                <h2 className="heading-two">Члени Палати зобов’язані:</h2>
                <ul>
                  <li>Активно сприяти здійсненню завдань і функцій Палати.</li>
                  <li>Своєчасно та у повному обсязі сплачувати вступні та членські внески.</li>
                  <li>
                    Здійснювати свою діяльність за принципами поваги до партнерства,
                    добропорядності, добросовісної конкуренції.
                  </li>
                </ul>
                <h2 className="heading-two">Припинення членства в Палаті</h2>
                <p className="paragraph">
                  Припинення членства в Палаті здійснюється на підставі письмової заяви до
                  Івано-Франківської ТПП. Член Палати, який не сплатив членські внески протягом
                  року, може бути виключений з членів Палати та ТПП України. У випадку невиконання
                  членом Палати обов&apos;язків, передбачених її Статутом, рішення про виключення
                  з членів Палати приймаються президією ІФ ТПП з подальшим повідомленням ТПП
                  України.
                </p>
                <h2 className="heading-two">Члени Івано-Франківської ТПП отримують такі можливості:</h2>
                <ul>
                  <li>
                    Інформаційна підтримка та участь у заходах Палати і ТПП України (виставки,
                    форуми, бізнес-місії, презентації).
                  </li>
                  <li>
                    Участь у міжнародних проектах для МСБ, які реалізує Івано-Франківська ТПП.
                  </li>
                  <li>
                    Навчальні заходи за участю національних та міжнародних експертів в
                    Івано-Франківську.
                  </li>
                  <li>
                    Ділові зустрічі членів Палати для обговорення актуальних питань (круглі столи,
                    тематичні заходи).
                  </li>
                  <li>
                    Розміщення контактної інформації вашого підприємства на сайтах
                    Івано-Франківської ТПП та ТПП України.
                  </li>
                </ul>
                <h2 className="heading-two">Контактна особа з питань членства в Івано-Франківській ТПП:</h2>
                <p className="paragraph">
                  Оксана ХМІЛЬОВСЬКА, +38(050) 28-29-794, e-mail: fea@cci.if.ua
                </p>
              </div>
              <div className="button-wrapper">
                <Button
                  priority="primary"
                  target="_blank"
                  link="/downloads/Заява на вступ в члени Палати.docx"
                  download
                >
                  {t('download_application_form')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
